import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Utils } from '../../../services/';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { loadWorkflow, deleteWorkflow } from '../../../redux/modules/workflows';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';


const WorkflowDelete = () => {
    const { workflowId } = useParams();
    const dispatch     = useDispatch();
    const { t }        = useTranslation();
    const default_lang = Utils.default_lang();

    const { workflow, isLoading, workflowSuccessfullyDeleted } = useSelector(state => state.workflows);

    useEffect(() => {
        dispatch(loadWorkflow(workflowId));
    }, []);

    const submit = (workflowId) => {
        dispatch(deleteWorkflow(workflowId));
    };

    let title = <span>{t("workflows.workflow", {count: 42})}</span>;
    if (workflow)
        title = (
            <span>
                <small> |&nbsp;{t('workflows.confirm_delete', { name: workflow.name[default_lang] })}</small>
            </span>
        );

    const actions =
        <div>
            <ButtonGroup>
                <Button tag={Link} to="/workflows" color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t("common.back")}
                </Button>
            </ButtonGroup>
        </div>

    return (
        <div className="WorkflowDelete">
            <PageTitle icon="code-fork" title={title} actions={actions} />

            {workflowSuccessfullyDeleted &&
                <Redirect to="/workflows" />
            }

            {workflow &&
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle><i className="fa fa-warning"></i>&nbsp;{t('workflows.confirm_delete')}</CardTitle>
                                <CardText tag="div">
                                <div><b>{t("workflows.name")}</b>: {workflow.name[default_lang]}</div>
                                <div dangerouslySetInnerHTML= {{__html: workflow.description[default_lang]}}></div>
                                <Row>
                                        <Col className="text-center">
                                            <Button tag={Link} to="/workflows" color="warning">
                                                <i className="fa fa-arrow-left"></i>&nbsp;{t('common.cancel')}
                                            </Button>&nbsp;
                                            <Button color="danger" onClick={(e) => submit(workflow.id)} disabled={isLoading}>
                                                {isLoading ?
                                                    <span>
                                                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                                    </span>
                                                    :
                                                    <span>
                                                        <i className="fa fa-trash"></i>&nbsp;
                                                        {t('common.delete')}
                                                    </span>
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }
        </div>
    );
}

export default WorkflowDelete;
